import Vue from 'vue';
import Antd from 'ant-design-vue/lib';
import 'ant-design-vue/dist/antd.css';

Vue.use(Antd);
